module.exports = "<chart [options]=\"options\"></chart>"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/spline-chart/spline-chart.component.html
// module id = ../../../../../src/app/shared/components/graphs/spline-chart/spline-chart.component.html
// module chunks = main